import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { PlatformOSGroupSearchParam } from '../models/platform-os-group-search-param.model';
import { PlatformOSGroup } from '../models/platform-os-group.model';
import { AlloxApiService } from './allox-api.service';


@Injectable({ providedIn: 'root' })
export class PlatformOSGroupService {

  private path = '/platform_os_groups';

  constructor(private http: AlloxApiService) { }

  public search(param?: PlatformOSGroupSearchParam) {
    let url = this.path;
    if (param) {
      url += param.toURLQuery();
    }
    return this.http.get<[]>(url).pipe(
      map(objs => objs.map(obj => new PlatformOSGroup(obj)))
    );
  }

  public fetch(platformId: number, mediaType: number, adFormat: number) {
    return this.http.get(this.path + '/' + platformId + '/' + mediaType + '/' + adFormat).pipe(
      map(obj => new PlatformOSGroup(obj))
    );
  }

  public post(item: PlatformOSGroup) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: PlatformOSGroup) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id, json);
  }
}
